import {membershipLabel} from "../../models/workspace-membership/workspace-membership-identity";

export function prepareTeamMemberRows(members, searchText = "", owner = null) {
    const query = String(searchText || "").trim().toLocaleLowerCase();
    const memberships = Array.isArray(members) ? [...members] : [];
    const ownerIdentifier = owner?.documentId || owner?.id;
    if (ownerIdentifier && !memberships.some((item) => String(item?.documentId || item?.id) === String(ownerIdentifier))) {
        memberships.unshift(owner);
    }

    return memberships
        .map((membership) => ({
            ...membership,
            fullname: membershipLabel(membership),
            email: membership?.member?.email || "",
            isOwner: String(membership?.documentId || membership?.id) === String(owner?.documentId || owner?.id),
            roleKey: "team.role.member",
            statusKey: `team.member.status.${membership?.memberShipStatus || "joined"}`,
        }))
        .filter((membership) => (
            !query || [membership.fullname, membership.email].some((value) => String(value || "").toLocaleLowerCase().includes(query))
        ));
}

export function teamMemberProfile(membership) {
    return membership?.member || membership || null;
}
